import React, { useState } from "react";
import RowExtension from "../../RowExtension/RowExtension";
import styles from "../style.module.css"
import classRequets from "../../../api/classRequest";

export default function StudentRow({ value }) {

  // console.log(value);
  const [dropFlag, setDropFlag] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [lastWPM, setLastWPM] = useState(0);
  const extendOrHide = async () => {
    try {

      if (!dropFlag) {
        let user = await classRequets.getOneUserDetails(value.id)
        console.log("🚀 ~ file: StudentRow.jsx:16 ~ extendOrHide ~ user:", user)
        setUserDetails(user)
        setDropFlag(true);
      }
      if (dropFlag) {
        setDropFlag(false)
      }
    } catch (error) {
      console.log("🚀  extendOrHide ~ error:", error)

    }
  }
  // const leng=(value.TF.length - 1)
  return (
    <>
      <div className={dropFlag ? `${styles.rowBox} ${styles.rowBoxOpen}` : styles.rowBox}>
        <div className={styles["rows"]} onClick={extendOrHide}      >
          <div className={styles["text_row"]}>{value.firstName + " " + value.lastName}</div>
          <div className={styles["text_row"]}>{value.asses}</div>
          <div className={styles["text_row"]}>{value.TR ? value?.TR.toFixed(0) : value.TR}</div>
          <div className={styles["text_row"]}>{value.TF ? value?.TF.toFixed(0) : value.TF}</div>

          <div
            className={styles["buttons"]}
          // onClick={() => {
          //   return <div>{value}</div>;
          // }}
          >
            <img
              className={styles[dropFlag ? "dropdownImg" : "dropdownImgUp"]}
              src={require("../TablePng/Polygon 2.png")}
              alt="some"
            />
          </div>
        </div>
        {dropFlag ? <RowExtension userDetails={userDetails} setLastWPM={setLastWPM} /> : ""}
      </div>
    </>
  );
}
